import React from 'react';
import styles from './styles.module.scss';

const Error = ({ message }) => (
  <div className={styles.error}>{message}</div>
)

Error.defaultProps = {
  message: 'An error occured while loading the data.'
}

export default Error;